var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right"},[_c('div',{staticClass:"title titleborder"},[_vm._v(" "+_vm._s(_vm.form.title || "--")+" "),_c('div',{staticClass:"rightreleaseTime"},[_vm._v(" 发布时间："+_vm._s(_vm.form.releaseTime || "--")+" ")])]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.form.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }